<script lang="ts">
    import {WalkerService} from 'shared/services';
    import {getInjector, getLocalization} from 'src/core';

    const localize = getLocalization();
    const walker = getInjector().getByClass(WalkerService);

    function redirect() {
        walker.newPage(`/saml2/authenticate/sso?redirect=${encodeURIComponent(window.location.href)}`);
    }
</script>

<div class="login-system login-system-saml2">
    <button class="btn btn-primary btn-block btn-saml2-login"
            data-qa="saml2-login-button"
            on:click={redirect}>
        {localize(/* @kp-localization login.PrihlasitSamlem */ 'login.PrihlasitSamlem')}
    </button>
</div>

<style lang="less">
    .btn-saml2-login {
        color: #fff;
        background-color: #993564;
        border-color: #7e1a47;
    }

    .btn-saml2-login:hover,
    .btn-saml2-login:focus {
        color: #fff;
        background-color: #85214d;
        border-color: #714;
    }

    .btn-saml2-login:active {
        color: #fff;
        background-color: #7e1a47;
        border-color: #514;
    }
</style>